<template>
    <div class="admin-marketing">
        <div>
            <!--Special Offers Section-->
            <div v-if="isSectionVisible('special-offers')" class="marketing-main-container">
                <div class="marketing-wrapper">
                    <div class="marketing-heading">
                        <h3>{{ $t("marketing.specialOffers") }}</h3>
                    </div>
                    <!--Special offers content container-->
                    <div v-if="!isLoading" class="marketing-content section-wrap">
                        <!--Show offer input toggle container-->
                        <div class="marketing-input-toggle">
                            <label for="show-offer" class="show-offer">
                                {{ $t("marketing.showOffer") }}
                            </label>
                            <div>
                                <label class="switch">
                                    <input id="show-offer" type="checkbox" v-model="showOffer"
                                        v-on:change="showOfferToggle" />
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>
                        <!--Write offer content container-->
                        <div class="marketing-content-offer highlighted-box section-wrap" v-if="showOffer">
                            <div v-if="showOffer" class="write-offer-wrap">
                                <!--Button links row-->
                                <div class="btns-wrap">
                                    <span v-if="!writeOffer" class="main-text-link" v-on:click="toggleWriteOffer">
                                        <span v-if="data.offer.length == 0">{{ $t("marketing.offerWrite") }}</span>
                                        <span v-if="data.offer.length > 0">{{ $t("marketing.editOffer") }}</span>
                                    </span>
                                    <span v-if="writeOffer" class="main-text-link" v-on:click="toggleWriteOffer">
                                        {{ $t("marketing.cancel") }}
                                    </span>
                                </div>
                                <!--Textarea row-->
                                <div class="marketing-textarea-wrap">
                                    <div class="textarea-text" v-if="!writeOffer">
                                        {{ data.offer }}
                                    </div>
                                    <div v-if="writeOffer" class="textarea-wrap">
                                        <div>
                                            <textarea placeholder="Write your special offer" class="text-field" rows="6"
                                                maxlength="140" v-on:keyup="countCharOffer()"
                                                v-model="specialOffer.text"></textarea>
                                        </div>
                                        <div class="counter-offer">{{ counter.offer }}/140</div>
                                    </div>
                                </div>
                                <!--Restrict row-->
                                <div v-if="showOffer && writeOffer" class="restrict-offer-wrapper">
                                    <div class="restrict-offer-wrap">
                                        <div class="restrict-label">
                                            <label for="restrict-user">{{ $t("marketing.restrict") }}:</label>
                                        </div>
                                        <div class="">
                                            <input id="restrict-user" type="text" class="text-field"
                                                placeholder="zipcode" aria-label="Title" maxlength="10"
                                                v-model="specialOffer.zip" />
                                        </div>
                                    </div>
                                    <div class="restrict-toggle-wrap">
                                        <label class="switch">
                                            <input type="checkbox" v-model="specialOffer.restricted" />
                                            <span class="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                                <!--Main save button-->
                                <div class="marketing-main-btn-wrap"
                                    v-if="specialOffer.active != showOffer || writeOffer">
                                    <div>
                                        <button v-bind:class="{ 'action-disabled': saveOfferInProgress }" type="button"
                                            class="primary-btn extra-small" v-on:click="saveSpecialOffer">
                                            {{ $t("marketing.saveOffer") }}
                                        </button>
                                    </div>
                                </div>
                                <div v-if="showOffer && data.offer != ''" class="marketing-gift-container">
                                    <div class="">
                                        <div class="offer-display"
                                            :style="{ backgroundColor: generalOptions.defaultColor }">
                                            <div class="gift-container">
                                                <i class="fa fa-gift"></i>
                                            </div>
                                            <div class="offer-text-message">
                                                {{ data.offer }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <MainLoader class="section-wrap" v-if="isLoading && isSectionVisible('special-offers')" />
                </div>
            </div>
            <!--Push Notifications Main Conatiner for all the Sections-->
            <div v-if="!isLoading" class="all-the-push-sections">
                <!--Push Notifications | First Section-->
                <div v-if="!preview && isSectionVisible('message-all-clients')" class="marketing-main-container">
                    <div class="marketing-wrapper">
                        <div class="marketing-heading">
                            <h3 v-if="!smsSection && !emailSection">
                                {{ $t("marketing.pushTextNotifications") }}
                            </h3>
                            <h3 v-if="emailSection">{{ $t("adminMenu.emailNotifications") }}</h3>
                            <h3 v-if="smsSection">{{ $t("marketing.smsNotifications") }}</h3>
                        </div>
                        <div class="marketing-content ">
                            <!--Select the type | section-->
                            <div class="push-notifications-wrapper highlighted-box section-wrap">
                                <div class="marketing-inner-heading">
                                    <h5 v-if="!smsSection && !emailSection">{{ $t("marketing.pushTextNotifications") }}
                                    </h5>
                                    <h5 v-if="smsSection">
                                        {{ $t("marketing.smsTextNotifications") }}
                                    </h5>
                                    <h5 v-if="emailSection">
                                        {{ $t("adminMenu.emailNotifications") }}
                                    </h5>
                                </div>
                                <div class="marketing-content-push-notifications">
                                    <div class="push-radio-inputs-wrap">
                                        <div v-if="!smsSection && !emailSection" class="push-form-check">
                                            <input class="radio-input" type="radio" id="push_notification" value="push"
                                                v-model="messageType" v-on:change="
                                                    checkTrimCars();
                                                checkCardForm();
                                                getLastCustomNotification();
                                                " />
                                            <label class="push-form-check-label" for="push_notification">
                                                {{ $t("marketing.pushNotification") }}
                                            </label>
                                        </div>
                                        <div v-if="
                                            adminDetails.profile &&
                                            smsSection /*&& sms_allowed_countries.indexOf(adminDetails.profile.country_id.toString()) > -1*/
                                        " class="push-form-check">
                                            <input class="radio-input" type="radio" id="sms_notification" value="sms"
                                                v-model="messageType" v-on:change="
                                                    checkTrimCars();
                                                checkCardForm();
                                                setMessagesNumberBuy();
                                                getLastCustomNotification();
                                                " />
                                            <label class="push-form-check-label" for="sms_notification">
                                                {{ $t("marketing.sms") }} ({{ availableSMS }}
                                                {{ $t("marketing.available") }})
                                            </label>
                                        </div>
                                        <div class="transaction-summary" v-if="
                                            adminDetails.profile &&
                                            smsSection /*&& sms_allowed_countries.indexOf(adminDetails.profile.country_id.toString()) > -1*/
                                        ">
                                            <span v-on:click="getCampaignLog('sms')"
                                                class="history-link main-text-link">{{
                                                    $t("marketing.transactionsSummary")
                                                }}</span>
                                        </div>
                                        <div v-if="!smsSection && emailSection" class="push-form-check">
                                            <input class="radio-input" type="radio" id="email_notification"
                                                value="email" v-model="messageType" v-on:change="
                                                    checkTrimCars();
                                                checkCardForm();
                                                setMessagesNumberBuy();
                                                getLastCustomNotification();
                                                " />
                                            <label class="push-form-check-label" for="email_notification">
                                                {{ $t("marketing.email") }} ({{ availableEmails }}
                                                {{ $t("marketing.available") }})
                                            </label>
                                        </div>
                                        <div v-if="!smsSection" class="transaction-summary">
                                            <span v-on:click="getCampaignLog('email')"
                                                class="history-link main-text-link">{{
                                                    $t("marketing.transactionsSummary") }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--Free text messages for subscription anniversay | section-->
                            <div v-if="isCountrySMSAllowed() == true && smsSection">
                                <div class="push-notifications-wrapper highlighted-box section-wrap" v-if="smsSection">
                                    {{ $t("marketing.weAreLoadingYourAccountWith") }} {{ sms_monthly_free }}
                                    {{ $t("marketing.freeTextMessage") }} ${{ sms_cost }}/
                                    {{ $t("marketing.messageText") }} (${{
                                        (sms_cost * sms_monthly_free).toFixed(2)
                                    }}).
                                </div>
                            </div>

                            <!--Write your message | section-->
                            <div class="push-notifications-wrapper highlighted-box section-wrap">
                                <!--Heading | Write your message-->
                                <div class="marketing-inner-heading">
                                    <h5>{{ $t("marketing.write") }}</h5>
                                </div>
                                <!--Main content container-->
                                <div class="marketing-content-push-notifications">
                                    <div class="write-message-wrapper">
                                        <!--Message Type-->
                                        <div class="message-type-wrap">
                                            <div v-if="messageType == 'push'" class="message-type">
                                                {{ $t("marketing.write_content") }}
                                            </div>
                                            <div v-if="messageType == 'sms'" class="message-type">
                                                {{ $t("marketing.write_content_sms") }}
                                            </div>
                                            <div v-if="messageType == 'email'" class="message-type">
                                                {{ $t("marketing.write_content_email") }}
                                            </div>
                                        </div>
                                        <!--Title-->
                                        <div v-if="messageType != 'sms'" class="input-group-wrap">
                                            <div class="inner-input-group-wrap">
                                                <input type="text" class="text-field" placeholder="Title"
                                                    aria-label="Title" maxlength="40" v-on:keyup="countChar('title')"
                                                    v-model="data.title" />
                                            </div>
                                            <div class="input-counter">{{ counter.title }}/40</div>
                                        </div>
                                        <!--Message textarea-->
                                        <div class="input-group-wrap">
                                            <div class="inner-input-group-wrap" :class="{
                                                'mb-3': messageType == 'email',
                                                'mb-1': (messageType == 'sms') | (messageType == 'push'),
                                            }">
                                                <input v-if="messageType == 'push'" type="text" class="text-field"
                                                    placeholder="Message" aria-label="Message" maxlength="160"
                                                    v-on:keyup="countChar('message')" v-model="data.message" />
                                                <textarea v-if="messageType != 'push'"
                                                    class="text-field expand-textarea" placeholder="Message"
                                                    aria-label="Message" :maxlength="messageType == 'sms' ? 160 : 2000"
                                                    v-on:keyup="countChar('message')" v-model="data.message"></textarea>
                                            </div>
                                            <div v-if="messageType != 'email'" class="input-counter">
                                                <span>{{ counter.message }}/160</span>
                                            </div>
                                            <div class="email-error-text section-wrap"
                                                v-if="messageType == 'email' && email_text_error != ''">
                                                {{ email_text_error }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--Send to | section-->
                                <div>
                                    <div class="marketing-inner-heading">
                                        <h5>{{ $t("marketing.sendTo") }}:</h5>
                                    </div>
                                    <div class="marketing-content-push-notifications">
                                        <div class="push-radio-inputs-wrap">
                                            <div class="push-form-check">
                                                <input class="radio-input" type="radio" name="sendToOpt"
                                                    id="sendToOptToday" value="today" v-model="data.onlyOpen"
                                                    v-on:change="checkCardForm" />
                                                <label class="push-form-check-label" for="sendToOptToday">
                                                    {{ $t("marketing.sendToOptToday") }}({{
                                                        details.total_active_clients_today
                                                    }})
                                                </label>
                                            </div>
                                            <div class="push-form-check">
                                                <input class="radio-input" type="radio" name="sendToOpt"
                                                    id="sendToOptTomorrow" value="tomorrow" v-model="data.onlyOpen"
                                                    v-on:change="checkCardForm" />
                                                <label class="push-form-check-label" for="sendToOptTomorrow">
                                                    {{ $t("marketing.sendToOptTomorrow") }}({{
                                                        details.total_active_clients_tomorrow
                                                    }})
                                                </label>
                                            </div>
                                            <div class="push-form-check">
                                                <input class="radio-input" type="radio" name="sendToOpt"
                                                    id="sendToOptWeek" value="this_week" v-model="data.onlyOpen"
                                                    v-on:change="checkCardForm" />
                                                <label class="push-form-check-label" for="sendToOptWeek">
                                                    {{ $t("marketing.sendToOptWeek") }}({{
                                                        details.total_active_clients_this_week
                                                    }})
                                                </label>
                                            </div>
                                            <div class="push-form-check">
                                                <input class="radio-input" type="radio" name="sendToOpt"
                                                    id="sendToOptNextWeek" value="next_week" v-model="data.onlyOpen"
                                                    v-on:change="checkCardForm" />
                                                <label class="push-form-check-label" for="sendToOptNextWeek">
                                                    {{ $t("marketing.sendToOptNextWeek") }}({{
                                                        details.total_active_clients_next_week
                                                    }})
                                                </label>
                                            </div>
                                            <div class="push-form-check">
                                                <input class="radio-input" type="radio" name="sendToOpt"
                                                    id="sendToOptOpen" value="open" v-model="data.onlyOpen"
                                                    v-on:change="checkCardForm" />
                                                <label class="push-form-check-label" for="sendToOptOpen">
                                                    {{ $t("marketing.sendToOptOpen") }}({{
                                                        details.total_active_clients
                                                    }})
                                                </label>
                                            </div>
                                            <div class="push-form-check">
                                                <input class="radio-input" type="radio" name="sendToOpt"
                                                    id="sendToOptAll" value="all" v-model="data.onlyOpen"
                                                    v-on:change="checkCardForm" />
                                                <label class="push-form-check-label" for="sendToOptAll">
                                                    {{ $t("marketing.sendToOptAll") }} ({{ details.total_clients
                                                    }})
                                                </label>
                                            </div>
                                            <div v-if="details.total_salon_clients && messageType === 'push'"
                                                class="push-form-check">
                                                <input class="radio-input" type="radio" name="sendToSlonAll"
                                                    id="sendToSlonAll" value="all_salon" v-model="data.onlyOpen"
                                                    v-on:change="checkCardForm" />
                                                <label class="push-form-check-label" for="sendToSlonAll">
                                                    {{ $t("marketing.sendToSalonAll") }} ({{
                                                        details.total_salon_clients
                                                    }})
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="messageType == 'sms'" class="marketing-content-push-notifications">
                                        <div v-if="!hasCard" class="add-payment-method-wrap">
                                            <span @click="scrollToPaymentMethod" class="main-text-link">
                                                {{ $t("marketing.addAtLeastOnePaymentMethod") }}</span>
                                        </div>
                                        <div v-if="!hasAvailableMessages()" class="push-radio-inputs-wrap">
                                            <!-- <div v-if="!hasCard">
                                        <div class="card-form" ref="braintree_card"></div>
                                        <div class="card-logos">
                                            <img class="verified" src="../../assets/images/verified-secured.jpg" />
                                        </div>
                                        <div class="card-errors">{{ cards_errors }}</div>
                                    </div> -->
                                            <div class="payment-form" v-if="isCountrySMSAllowed() == true">
                                                <div>
                                                    <span>{{ $t("marketing.buy") }}</span>
                                                    <input placeholder="number of sms" type="number"
                                                        v-model="buyMessagesNumber"
                                                        class="messages-number-input text-field"
                                                        v-on:change="checkMessagesNumberBuy" />
                                                </div>
                                                <div>
                                                    <span>{{ messageType == "sms" ? "SMS" : "Emails" }} for ${{
                                                        getTotalMessageCost()
                                                        }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="terms-and-conditions-wrap">
                                            <h6 v-on:click="showTermsModal" class="main-text-link">
                                                <span class="terms-and-conditions-link">{{ $t("marketing.terms")
                                                    }}</span>
                                            </h6>
                                            <div class="push-form-checkbox">
                                                <label class="switch" for="agreeTerms"><input type="checkbox"
                                                        name="agreeTerms" id="agreeTerms" value="1"
                                                        v-model="agreeTerms" />
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="push-form-check-label" for="agreeTerms">
                                                    {{ $t("marketing.agreeTerms") }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="preview-btn-wrap">
                                        <div>
                                            <button v-bind:class="{
                                                'action-disabled':
                                                    sendNotificationInProgress ||
                                                    loading ||
                                                    (messageType == 'sms' && !agreeTerms) ||
                                                    data.message == '' ||
                                                    (messageType != 'sms' && data.title == '') ||
                                                    clientsNumber == 0,
                                            }" type="button" class="primary-btn extra-small"
                                                v-on:click="onCampaignPreview">
                                                {{
                                                    messageType != "push" && !hasAvailableMessages()
                                                        ? $t("marketing.buy_preview")
                                                        : $t("marketing.preview")
                                                }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--Last you sent: | section-->
                            <div v-if="details.message != null && details.message != ''">
                                <div class="push-notifications-wrapper highlighted-box section-wrap"
                                    v-if="messageType == 'push' || messageType == 'sms' || messageType == 'email'">
                                    <!--Push-->
                                    <div v-if="messageType == 'push'" class="last-message-sent-wrap">
                                        <div class="last-message-heading">
                                            <h5>{{ $t("marketing.messageLast") }}:</h5>
                                        </div>
                                        <div class="last-message-content">
                                            <div class="title-message-wrap">
                                                <div class="details-title">{{ details.title }}</div>
                                                <div class="details-message">{{ details.message }}</div>
                                            </div>
                                            <div class="details-date">
                                                <div>
                                                    {{ details.date }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--Email-->
                                    <div v-if="messageType == 'email'" class="last-message-sent-wrap">
                                        <div class="last-message-heading">
                                            <h5>{{ $t("marketing.messageLast") }}:</h5>
                                        </div>
                                        <div class="last-message-content">
                                            <div class="title-message-wrap">
                                                <div class="details-title">
                                                    {{ last_email_title_send }}
                                                </div>
                                                <div class="details-message">
                                                    {{ last_email_message_send }}
                                                </div>
                                            </div>
                                            <div class="details-date">
                                                <div>
                                                    {{ details.date }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--SMS-->
                                    <div v-if="messageType == 'sms'" class="last-message-sent-wrap">
                                        <div class="last-message-heading">
                                            <h5>{{ $t("marketing.messageLast") }}:</h5>
                                        </div>
                                        <div class="last-message-content">
                                            <div>
                                                <div>{{ details.message }}</div>
                                            </div>
                                            <div>
                                                <div>
                                                    {{ details.date }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <!--Push Notifications | Preview Section-->
                <div v-if="preview && isSectionVisible('message-all-clients')" class="marketing-main-container">
                    <div class="marketing-wrapper">
                        <div class="marketing-heading">
                            <h3>{{ $t("marketing.textMessagePreview") }}</h3>
                        </div>
                        <div class="marketing-content">
                            <div class="push-notifications-wrapper highlighted-box section-wrap">
                                <div class="marketing-inner-heading">
                                    <h5>{{ $t("marketing.textMessagePreview") }}</h5>
                                    <p>( {{ $t("marketing.seeBelowWhatYouAreAboutToSend") }} )</p>
                                </div>

                                <div class="marketing-content-push-notifications">
                                    <div class="preview-content-wrap">
                                        <div class="preview-text-wrap section-wrap" v-if="messageType != 'sms'">
                                            <div class="preview-heading">Title:</div>
                                            <span class="preview-note">{{ data.title }}</span>
                                        </div>
                                        <div class="preview-text-wrap section-wrap">
                                            <div class="preview-heading">Message:</div>
                                            <span class="preview-note message-sent">{{ data.message }} </span>
                                        </div>
                                        <div v-if="messageType != 'push'" class="preview-text-wrap section-wrap">
                                            <div class="preview-heading">Notes</div>

                                            <div class="preview-notes-wrap">
                                                <span class="preview-note">
                                                    * {{ $t("marketing.theMessageWillBeSentTo") }} {{ clientsNumber
                                                    }}
                                                    {{ $t("marketing.ofYourClients") }}.
                                                </span>
                                                <span class="preview-note">
                                                    * {{ $t("marketing.itWillConsume") }} {{ clientsNumber }}
                                                    {{ messageType == "sms" ? "SMS" : "Email" }}
                                                    {{ $t("marketing.messagesFromThe") }}
                                                    {{ messageType == "sms" ? availableSMS : availableEmails }}
                                                    {{ messageType == "sms" ? "SMS" : "Email" }}
                                                    {{ $t("marketing.youHaveAvailable") }}.
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="preview-btns-wrap">
                                        <div>
                                            <button type="button" class="secondary-btn small mobile">
                                                <a v-on:click="
                                                    getCampaignSettings();
                                                preview = false;
                                                ">{{ $t("marketing.goBack") }}</a>
                                            </button>
                                        </div>
                                        <div>
                                            <button
                                                v-bind:class="{ 'action-disabled': sendNotificationInProgress || loading }"
                                                type="button" class="primary-btn extra-small mobile"
                                                v-on:click="onCampaignSend">
                                                {{ $t("marketing.send") }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Push Notifications | Payment Methods Section-->
                <div v-if="isSectionVisible('message-all-clients') && smsSection && !preview"
                    class="marketing-main-container">
                    <div class="marketing-wrapper">
                        <div class="marketing-content payment-methods-wrap">
                            <div class="push-notifications-wrapper highlighted-box section-wrap">
                                <div class="marketing-inner-heading" id="add-payment-method">
                                    <h5>{{ $t("adminMenu.paymentMethods") }}</h5>
                                </div>
                                <div class="marketing-content-push-notifications">
                                    <div class="content-wrap">
                                        <div v-if="braintree_cards.length > 0"
                                            class="payment-cards-container section-wrap">
                                            <div class="border-wrap">
                                                <div v-if="braintree_cards.length > 0" class="payment-methods-head">
                                                    <div>{{ $t("marketing.number") }}</div>
                                                    <div>{{ $t("marketing.expiration") }}</div>
                                                    <div>{{ $t("marketing.type") }}</div>
                                                </div>
                                                <div v-for="(method, i) in braintree_cards" :key="i"
                                                    class="braintree-cards-wrapper">
                                                    <div class="braintree-card-wrap">
                                                        <div class="braintree-cards-cards">
                                                            {{ $t("marketing.number") }}
                                                        </div>
                                                        <div>***{{ method.last4 }}</div>
                                                    </div>
                                                    <div class="braintree-card-wrap">
                                                        <div class="braintree-cards-cards">
                                                            {{ $t("marketing.expiration") }}
                                                        </div>
                                                        <div>{{ method.expirationMonth }}/{{ method.expirationYear }}
                                                        </div>
                                                    </div>
                                                    <div class="braintree-card-wrap">
                                                        <div class="braintree-cards-cards">
                                                            {{ $t("marketing.type") }}
                                                        </div>
                                                        <div>{{ method.cardType }}</div>
                                                    </div>
                                                    <div class="braintree-card-wrap">
                                                        <div>
                                                            <span class="primary-btn extra-small default-method" v-if="
                                                                default_payment_method == method.payment_method_token ||
                                                                (!default_payment_method && !method.default)
                                                            ">{{ $t("marketing.default") }}</span>
                                                            <span class="primary-btn extra-small" v-if="
                                                                (default_payment_method !=
                                                                    method.payment_method_token ||
                                                                    (!default_payment_method && !method.default)) &&
                                                                !loading
                                                            " v-on:click="setDefaultCard(method.payment_method_token)">{{
                                                                $t("marketing.defaultForSMSPurchase") }}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div>
                                                            <span class="delete-card primary-btn extra-small" v-if="
                                                                default_payment_method != method.payment_method_token &&
                                                                !method.default &&
                                                                !loading
                                                            " v-on:click="
                                                                deleteBraintreeCard(method.payment_method_token)
                                                                ">{{ $t("marketing.delete") }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="displayNewBraintreeCardForm" class="stripe-card-wrap section-wrap">
                                            <div class="card-form" ref="braintree_card"></div>
                                            <div class="card-logos">
                                                <img class="verified" src="../../assets/images/verified-secured.jpg" />
                                            </div>
                                            <div class="card-errors">{{ cards_errors }}</div>

                                            <div class="terms-and-conditions-wrap">
                                                <h6 v-on:click="showTermsModal" class="main-text-link">
                                                    <span class="terms-and-conditions-link">
                                                        {{ $t("marketing.terms") }}</span>
                                                </h6>
                                                <div class="push-form-checkbox">
                                                    <label for="agreeCardTerms" class="switch"><input
                                                            id="agreeCardTerms" type="checkbox"
                                                            v-model="agreeCardTerms" />

                                                        <span class="slider round"></span></label>
                                                    <label for="agreeCardTerms" class="push-form-check-label">{{
                                                        $t("marketing.agreeTerms")
                                                        }}</label>
                                                </div>
                                            </div>
                                            <div class="action-buttons-wrap">
                                                <div>
                                                    <button v-on:click="saveCard" type="button"
                                                        class="primary-btn extra-small"
                                                        :disabled="loading || !agreeCardTerms">
                                                        {{ $t("marketing.addCard") }}
                                                    </button>
                                                </div>
                                                <div>
                                                    <button v-on:click="
                                                        displayNewBraintreeCardForm = false;
                                                    agreeCardTerms = false;
                                                    " type="button" class="secondary-btn small" :disabled="loading">
                                                        {{ $t("marketing.cancel") }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="cards_errors" class="card-errors-wrap">
                                            Error adding the card: {{ cards_errors }}
                                        </div>
                                        <div v-if="!displayNewBraintreeCardForm" class="action-buttons-wrap">
                                            <div>
                                                <button type="button" class="primary-btn extra-small"
                                                    v-on:click="addNewBraintreeCard">
                                                    {{ $t("marketing.addNewCard") }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <!--Push Notifications | Manual Payment Section-->
                <div v-if="isSectionVisible('message-all-clients') && smsSection && !preview && isCountrySMSAllowed() == true"
                    class="marketing-main-container">
                    <div class="marketing-wrapper">
                        <div class="marketing-content ">
                            <div class="push-notifications-wrapper highlighted-box section-wrap">
                                <div class="marketing-inner-heading">
                                    <h5>{{ $t("marketing.manualPayment") }}</h5>
                                </div>

                                <div class="marketing-content-push-notifications">
                                    <div class="content-wrap">
                                        <div class="section-wrap">
                                            <div class="sms-amount-wrap">
                                                <label>{{ $t("marketing.smsAmount") }}</label>
                                                <div class="sms-input-wrap">
                                                    <div>
                                                        <input type="number" class="text-field"
                                                            v-model="buyMessagesNumber" />
                                                    </div>
                                                    <div>
                                                        SMS x ${{ sms_cost }} = ${{
                                                            (sms_cost * buyMessagesNumber).toFixed(2)
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="terms-and-conditions-wrap">
                                                <h6 v-on:click="showTermsModal" class="main-text-link">
                                                    <span class="terms-and-conditions-link">{{
                                                        $t("marketing.terms")
                                                        }}</span>
                                                </h6>
                                                <div class="push-form-checkbox">
                                                    <label class="switch">
                                                        <input type="checkbox" name="agreeTerms-2" id="agreeTerms-2"
                                                            v-model="agreeTerms" />
                                                        <span class="slider round"></span></label>

                                                    <label class="push-form-check-label" for="agreeTerms-2">
                                                        {{ $t("marketing.agreeTerms") }}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="action-buttons-wrap">
                                            <div v-if="braintree_cards.length == 0" class="mt-2 pull-right text-danger">
                                                {{ $t("marketing.noCreditCardOnFile") }}.
                                            </div>
                                            <div>
                                                <button v-on:click="manualChargePayment" :class="loading ||
                                                    !agreeTerms ||
                                                    braintree_cards.length == 0 ||
                                                    buyMessagesNumber < 100 ? 'disabled-button' : ''" type="button"
                                                    class="primary-btn extra-small">
                                                    {{ $t("marketing.pay") }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Push Notifications | Auto Reload SMS Section-->
                <div v-if="isSectionVisible('message-all-clients') && smsSection && !preview && isCountrySMSAllowed() == true"
                    class="marketing-main-container">
                    <div class="marketing-wrapper">
                        <div class="marketing-content ">
                            <div class="push-notifications-wrapper highlighted-box section-wrap">
                                <div class="marketing-inner-heading">
                                    <h5>{{ $t("marketing.autoreloadSMS") }}</h5>
                                </div>

                                <div class="marketing-content-push-notifications">
                                    <div class="content-wrap">
                                        <div class="inner-content-wrap section-wrap container-for-text-error">
                                            <div class="auto-reload-wrap">
                                                <label for="reload">{{ $t("marketing.autoReload") }}</label>
                                                <label class="switch">
                                                    <input id="reload" type="checkbox" v-model="autoreload_sms" />
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                            <div class="sms-amount-wrap">

                                                <label>{{ $t("marketing.smsAmount") }}</label>

                                                <div class="sms-input-wrap">
                                                    <div>
                                                        <input type="tel" class="text-field"
                                                            v-model="autoreload_sms_number"
                                                            @keyup="filterAmountAutoReload" />
                                                    </div>
                                                    <div>
                                                        {{ $t("marketing.sms") }} x ${{ sms_cost }} = ${{
                                                            (sms_cost * autoreload_sms_number).toFixed(2)
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                            <span class="error-text" v-if="autoreload_sms_number < 100">A minimum
                                                purchase
                                                of 100 is required for text messages.
                                            </span>
                                            <div class="sms-amount-wrap">
                                                <label>{{ $t("marketing.whenSmsBalanceIsBelow") }}</label>
                                                <div class="sms-input-wrap">
                                                    <div>
                                                        <input type="number" class="text-field"
                                                            v-model="autoreload_sms_limit" />
                                                    </div>
                                                    <div>{{ $t("marketing.sms") }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="action-buttons-wrap">
                                            <div v-if="braintree_cards.length == 0" class="pull-right text-danger">
                                                {{ $t("marketing.noCreditCardOnFile") }}.
                                            </div>
                                            <div>
                                                <button v-on:click="saveAutoreloadSmsSettings" :disabled="loading ||
                                                    braintree_cards.length == 0 ||
                                                    autoreload_sms_number < 100
                                                    " type="button" class="primary-btn extra-small" :class="loading ||
                                                        braintree_cards.length == 0 ||
                                                        autoreload_sms_number < 100 ? 'disabled-button' : ''">
                                                    {{ $t("marketing.save") }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MainLoader v-if="isLoading && !isSectionVisible('special-offers')" class="section-wrap" />
        </div>
        <!-- Modal Terms and Conditions -->
        <div class="modal fade" id="terms-modal" tabindex="-1" aria-labelledby="terms-modal-label" aria-hidden="true"
            data-bs-backdrop="false">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="terms-modal-label">
                            {{ $t("marketing.terms") }}
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body">
                        <div class="terms-list-container section-wrap">
                            <ul class="terms-list">
                                <li>{{ $t("marketing.smsMessagesAreLimited") }}.</li>
                                <li>{{ $t("marketing.youCanOnlyUseTextMessages") }}.</li>
                                <li>{{ $t("marketing.unlessWeStateInWritingOtherwise") }}.</li>
                                <li>{{ $t("marketing.theRemainingSmsMessagesAreNotRefundable") }}.</li>
                                <li>{{ $t("marketing.theRemainingEmailsAreNotRefundable") }}.</li>
                                <li v-if="smsSection && isCountrySMSAllowed()">
                                    {{ $t("marketing.costPerSms") }} ${{ sms_cost }}.
                                </li>
                                <li v-if="!smsSection">
                                    {{ $t("marketing.costPerEmail") }}.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- History Modal -->
        <div class="modal fade" id="history-modal" tabindex="-1" aria-labelledby="history-modal-label"
            aria-hidden="true" data-bs-backdrop="false">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">

                    <!-- Header -->
                    <div class="modal-header">
                        <h5 class="modal-title" id="history-modal-label">
                            {{ $t("marketing.transactionsSummary") }}
                        </h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                    </div>

                    <!-- Body -->
                    <div class="modal-body">
                        <div class="history-list-container">
                            <div class="history-content-wrap">

                                <div class="history-content-heading">
                                    <span v-if="logDisplayType === 'email'">
                                        {{ campaignLogTotal }}
                                        {{ $t("marketing.emailMessagesSent") }}.
                                    </span>

                                    <span v-if="logDisplayType === 'email'">
                                        {{ availableEmails + " Email" }}
                                        {{ $t("marketing.messagesRemain") }}.
                                    </span>
                                </div>

                                <!-- SMS LOGS -->
                                <div v-if="logDisplayType === 'sms'" class="history-log-wrap section-wrap">
                                    <div v-for="(item, i) in campaignLogSMS" :key="i"
                                        class="history-log-item section-wrap">
                                        <h5>{{ item.month }}</h5>

                                        <div>
                                            <strong>{{ item.total_sent }}</strong>
                                        </div>

                                        <div v-for="(log, k) in item.log" :key="`items_${k}`"
                                            class="history-log-item section-wrap">
                                            {{ log }}
                                        </div>

                                        <div v-if="item.sent_to_clients.log.length > 0">
                                            <div>
                                                <strong>{{ item.sent_to_clients.total }}</strong>
                                            </div>

                                            <div v-for="(lg, k) in item.sent_to_clients.log"
                                                :key="`sent_to_clients_${k}`" class="history-log-item section-wrap">
                                                {{ lg }}
                                            </div>
                                        </div>

                                        <div v-if="item.sent_to_stylist.log.length > 0">
                                            <div>
                                                <strong>{{ item.sent_to_stylist.total }}</strong>
                                            </div>

                                            <div v-for="(lg, k) in item.sent_to_stylist.log"
                                                :key="`sent_to_stylists_${k}`" class="history-log-item section-wrap">
                                                {{ lg }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- EMAIL LOGS -->
                                <div v-if="logDisplayType === 'email' && campaignLog.length > 0"
                                    class="history-log-wrap section-wrap">
                                    <div v-for="(item, i) in campaignLog" :key="i"
                                        class="history-log-item section-wrap">
                                        {{ item.number }}
                                        {{ logDisplayType === "sms" ? "SMS" : "Emails" }}
                                        {{ item.event_type === "send" ? "sent" : "purchased" }}
                                        on
                                        {{ getFormattedDate(item.created_at, "MMM DD YYYY") }}
                                    </div>
                                </div>

                                <!-- NO TRANSACTIONS -->
                                <div v-if="logDisplayType === 'email' && campaignLog.length === 0"
                                    class="history-log-wrap section-wrap">
                                    <span class="no-transactions">
                                        {{ $t("marketing.noTransactionsSummary") }}
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import auth from "./../../services/auth.js";
import api from "../../services/apiEndpoints.js";
import store from "./../../services/vuex.js";
import messages from "./../../services/messages.js";
import moment from "moment";
import eventBus from "../../services/eventBus.js";
import $ from "jquery";
import MainLoader from "./general-components/MainLoader.vue";
import { Modal } from 'bootstrap';

export default {
    name: "AdminSchedule",
    props: ["sections", "smsSection", "emailSection"],
    data: function () {
        return {
            counter: {
                title: 0,
                message: 0,
                offer: 0,
            },
            data: {
                title: "",
                message: "",
                onlyOpen: "today",
                offer: "",
            },
            details: {
                title: 0,
                message: 0,
                date: "",
                total_active_clients_next_week: 0,
                total_active_clients_this_week: 0,
                total_active_clients_today: 0,
                total_active_clients_tomorrow: 0,
                total_active_clients: 0,
                total_clients: 0,
                total_salon_clients: 0,
            },
            specialOffer: {
                active: 0,
                restricted: 1,
                text: "",
                zip: "",
            },
            writeOffer: false,
            showOffer: false,

            sendNotificationInProgress: false,
            saveOfferInProgress: false,
            saveProfileInProgress: false,
            availableSMS: 0,
            availableEmails: 0,
            buyMessagesNumber: 100,
            messageType: "push",
            agreeTerms: false,
            hasCard: true,
            card_errors: "",
            loading: false,
            cards_errors: "",
            sms_cost: 0,
            sms_free_initial: 100,
            sms_free_initial_total_cost: 0,
            sms_monthly_free: 0,
            email_cost: import.meta.env.VITE_EMAIL_COST,
            sms_allowed_countries: [],
            preview: false,
            clientsNumber: 0,
            campaignLog: [],
            campaignLogTotal: 0,
            campaignLogSMS: [],
            logDisplayType: "",
            minSMSBuyNumber: 100,
            minEmailBuyNumber: 1000,
            displayNewBraintreeCardForm: false,
            braintree_client_token: "",
            braintree_dropin_instance: null,
            braintree_cards: [],
            default_payment_method: "",
            agreeCardTerms: false,
            autoreload_sms: false,
            autoreload_sms_number: 100,
            autoreload_sms_limit: 0,
            email_text_error: "",
            last_email_title_send: "",
            last_email_message_send: "",
            isLoading: true,
        };
    },
    mounted: function () {
        this.user = auth.state.user;
        this.for_stylist_id = auth.state.user.id;

        this.sms_allowed_countries = import.meta.env.VITE_SMS_ALLOWED_COUNTRIES.split(",");

        if (this.smsSection) {
            this.messageType = "sms";
        }

        if (this.emailSection) {
            this.messageType = "email";
        }

        //check if adminDetails are either in store or loaded
        //if yes then do necessary logic
        if (this.$store.state.adminDetails.user) {
            this.onAdminDetailsLoad();
        }
        let self = this;
        eventBus.on("admin_details_loaded", function () {
            self.onAdminDetailsLoad();
        });


    },
    watch: {
        smsSection: function () {
            if (this.smsSection) {
                this.messageType = "sms";
            }
            //else {
            //     this.messageType = "push";
            // }
            this.checkTrimCars();
            this.checkCardForm();
            this.setMessagesNumberBuy();
            this.getLastCustomNotification();
        },

        emailSection: function () {
            if (this.emailSection) {
                this.messageType = "email";
            }
        }
    },
    beforeUnmount() {
        eventBus.off("admin_details_loaded");
    },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
        groupMembers: {
            get: function () {
                return this.$store.state.stylists;
            },
            set: function (value) {
                this.$store.commit("setStylists", value);
            },
        },
    },
    methods: {
        showOfferToggle() {
            if (!this.showOffer) {
                this.saveSpecialOffer();
            }
        },
        scrollToPaymentMethod() {
            const targetElement = document.getElementById("add-payment-method");

            if (targetElement) {
                const scrollPosition = targetElement.offsetTop - window.innerHeight / 2;

                window.scrollTo({
                    top: scrollPosition,
                    behavior: "smooth",
                });
            }
        },
        isSectionVisible(section) {
            if (!this.sections) {
                return true;
            }

            return this.sections.indexOf(section) !== -1;
        },
        countChar: function (type) {
            this.counter[type] = this.data[type].length;
        },
        countCharOffer: function () {
            this.counter.offer = this.specialOffer.text.length;
        },
        toggleWriteOffer: function () {
            this.writeOffer = !this.writeOffer;
            this.countChar("offer");
        },
        isCountrySMSAllowed() {
            if (!this.adminDetails.profile) {
                return false;
            }
            let profileCountryId = this.adminDetails.profile.country_id;
            let countriesAllowed = this.sms_allowed_countries;

            return countriesAllowed.includes(profileCountryId.toString());
        },
        onAdminDetailsLoad: function () {
            this.getLastCustomNotification();
            this.getSpecialOffer();
            this.getCampaignSettings();
            this.checkUserCard();
            if (this.sms_allowed_countries.indexOf(this.adminDetails.profile.country_id.toString()) > -1) {
                this.sms_cost = import.meta.env["VITE_SMS_COST_" + this.adminDetails.profile.country_id];
                this.sms_monthly_free = import.meta.env["VITE_MONTHLY_SMS_NUM_" + this.adminDetails.profile.country_id];
                this.sms_free_initial = 100;
            } else {
                this.sms_cost = import.meta.env["VITE_SMS_COST_0"];
                this.sms_monthly_free = import.meta.env["VITE_MONTHLY_SMS_NUM"];
                this.sms_free_initial = 50;
            }
            this.sms_free_initial_total_cost = (this.sms_cost * this.sms_free_initial).toFixed(2);
        },
        getLastCustomNotification: function () {
            this.email_text_error = "";
            let additionalQuery = "";

            if (this.adminDetails.group_active == 1 && this.adminDetails.group_owner == 1) {
                additionalQuery = "&include_group_clients_count=" + this.adminDetails.group_id;
            }

            this.$http
                .get(api.actions.get_last_custom_notification + "?type=" + this.messageType + additionalQuery)
                .then(
                    function (response) {
                        if (typeof response.data.details != "undefined" && response.data.details) {
                            if (typeof response.data.details.date !== "undefined") {
                                this.details.date = moment(response.data.details.date).format("MMMM DD / hh:ss A");
                            }
                            this.details.title = response.data.details.title;
                            this.details.message = response.data.details.message;
                            this.details.total_active_clients_next_week = response.data.total_active_clients_next_week;
                            this.details.total_active_clients_this_week = response.data.total_active_clients_this_week;
                            this.details.total_active_clients_today = response.data.total_active_clients_today;
                            this.details.total_active_clients_tomorrow = response.data.total_active_clients_tomorrow;
                            this.details.total_active_clients = response.data.total_active_clients;
                            this.details.total_clients = response.data.total_clients;
                            this.details.total_salon_clients = response.data.total_salon_clients;
                            this.clientsNumber = this.getSelectedGroupNumber();
                            this.resetForm();
                            this.setMessagesNumberBuy();
                            this.splitText();
                            this.isLoading = false;
                        }
                    }.bind(this),
                    function () {
                        return false;
                    }
                );
        },
        resetForm: function () {
            this.data.title = "";
            this.data.message = "";
            this.countChar("title");
            this.countChar("message");
        },
        sendCustomNotification: function () {
            let data = {
                title: this.data.title,
                message: this.data.message,
            };
            if (data.title.length == 0 || data.message.length == 0) {
                messages.errorMessage("Title of message cannot be empty");
                return;
            }
            if (
                this.data.onlyOpen != "all" &&
                this.data.onlyOpen != "all_salon" &&
                this.details.total_active_clients == 0
            ) {
                messages.errorMessage("There are no clients to send notification to.");
                return;
            }
            if (this.data.onlyOpen == "all" && this.details.total_salon_clients == 0) {
                messages.errorMessage("There are no clients to send notification to.");
                return;
            }

            if (this.data.onlyOpen == "all_salon" && this.details.total_salon_clients == 0) {
                messages.errorMessage("There are no clients to send notification to.");
                return;
            }

            //make only_open
            switch (this.data.onlyOpen) {
                case "today":
                case "tomorrow":
                case "this_week":
                case "next_week":
                    data.only_open = 1;
                    data.only_open_interval = this.data.onlyOpen;
                    break;
                case "open":
                    data.only_open = 1;
                    break;
                case "all":
                case "all_salon":
                    data.only_open = 0;
                    break;
            }

            if (this.data.onlyOpen == "all_salon") {
                data.group_send = this.adminDetails.group_id;
            }

            this.sendNotificationInProgress = true;
            this.$http.post(api.actions.send_custom_notification, data).then(
                function (response) {
                    this.sendNotificationInProgress = false;
                    if (response.data.error == false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.CUSTOM_NOTIFICATION_SENT);
                        this.getLastCustomNotification();
                        this.preview = false;
                        this.data.title = "";
                        this.data.message = "";
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
        getSpecialOffer: function () {

            if (!this.user) {
                return;
            }

            this.isLoading = true;
            this.$http.post(api.actions.get_special_offer, { id: this.user.id }).then(
                function (response) {
                    if (typeof response.data.special_offer != "undefined" && response.data.special_offer) {
                        this.specialOffer.active = response.data.special_offer.active;
                        this.specialOffer.restricted = response.data.special_offer.restricted;
                        this.specialOffer.text = response.data.special_offer.text;
                        this.specialOffer.zip = response.data.special_offer.zip;

                        this.showOffer = Boolean(response.data.special_offer.active);
                        this.data.offer = this.specialOffer.text;

                        this.writeOffer = false;
                        this.isLoading = false;
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
        saveSpecialOffer: function () {
            let data = {
                restricted: this.specialOffer.restricted,
                zip: this.specialOffer.zip,
                text: this.specialOffer.text,
                active: this.showOffer,
            };
            if (this.showOffer && this.specialOffer.text.length == 0) {
                messages.errorMessage("Text is required when offer is active");
                return;
            }
            this.saveOfferInProgress = true;
            this.$http.post(api.actions.save_special_offer, data).then(
                function (response) {
                    this.saveOfferInProgress = false;
                    if (response.data.error == false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.SAVE_OFFER_SUCCESS);
                        this.getSpecialOffer();
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
        getStylistDetails: function () {
            this.$http.get(api.actions.get_stylist_details + this.user.id).then(
                function (response) {
                    if (typeof response.data.details !== "undefined") {
                        // let allInfoDetails = response.data;
                        let adminDetails = response.data.details;
                        this.$store.commit("setAdminDetails", adminDetails);
                        eventBus.emit("admin_details_loaded");
                    }
                }.bind(this)
            );
        },
        getCampaignSettings: function () {
            this.$http.get(api.actions.get_marketing_campaign_settings).then(
                function (response) {
                    if (typeof response.data.settings !== "undefined") {
                        this.availableSMS = response.data.settings.available_sms;
                        this.default_payment_method = response.data.settings.payment_method;
                        this.autoreload_sms = Boolean(response.data.settings.autoreload_sms);
                        this.autoreload_sms_number = response.data.settings.autoreload_sms_number;
                        this.autoreload_sms_limit = response.data.settings.autoreload_sms_limit;

                        this.availableEmails = response.data.settings.available_emails;
                    }
                }.bind(this)
            );
        },
        checkTrimCars: function () {
            if (this.messageType != "email" && this.data.message.length > 160) {
                this.data.message = this.data.message.substr(0, 160);
                this.counter.message = 160;
            }
        },
        showTermsModal() {
            const modalEl = document.getElementById("terms-modal");
            let modal = Modal.getInstance(modalEl);

            if (!modal) {
                modal = new Modal(modalEl);
            }

            modal.show();
        },
        hasAvailableMessages: function () {
            var clients = this.getSelectedGroupNumber();
            var messages = 0;

            switch (this.messageType) {
                case "sms":
                    messages = this.availableSMS;
                    break;
                case "email":
                    messages = this.availableEmails;
                    break;
            }

            this.clientsNumber = clients;
            var available = messages > clients;

            return available;
        },
        getSelectedGroupNumber() {
            var clients = 0;

            switch (this.data.onlyOpen) {
                case "tomorrow":
                    clients = this.details.total_active_clients_tomorrow;
                    break;
                case "today":
                    clients = this.details.total_active_clients_today;
                    break;
                case "this_week":
                    clients = this.details.total_active_clients_this_week;
                    break;
                case "next_week":
                    clients = this.details.total_active_clients_next_week;
                    break;
                case "open":
                    clients = this.details.total_active_clients;
                    break;
                case "all":
                    clients = this.details.total_clients;
                    break;
                case "all_salon":
                    clients = this.details.total_salon_clients;
                    break;
            }

            return clients;
        },
        checkUserCard() {
            this.$http.get(api.actions.get_braintree_customer_cards).then((response) => {
                if (response.data.error == true || !response.data.response.length) {
                    this.hasCard = false;
                    return;
                }

                this.hasCard = true;
                this.braintree_cards = response.data.response;
            });
        },

        setDefaultCard(card_id) {
            this.loading = true;

            this.$http
                .post(api.actions.save_marketing_campaign_payment_method, { payment_method: card_id })
                .then(() => {
                    this.loading = false;
                    this.default_payment_method = card_id;
                    this.checkUserCard();
                    this.getCampaignSettings();
                });
        },

        deleteBraintreeCard(card_id) {
            this.$swal({
                title: "Are you sure you want to delete the payment method?",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    this.loading = true;

                    this.$http
                        .post(api.actions.delete_braintree_customer_cards, { payment_method_token: card_id })
                        .then(() => {
                            this.loading = false;
                            this.checkUserCard();
                        });
                }
            });
        },

        addNewBraintreeCard() {
            this.displayNewBraintreeCardForm = true;

            if (!this.$refs.braintree_card) {
                setTimeout(() => {
                    this.addNewBraintreeCard();
                }, 100);
                return;
            }

            this.$http.get(api.actions.get_braintree_client_token).then((response) => {
                this.braintree_client_token = response.data.client_token;

                window.braintree.dropin.create(
                    {
                        authorization: this.braintree_client_token,
                        container: this.$refs.braintree_card,
                    },
                    (error, dropinInstance) => {
                        if (!dropinInstance) {
                            return;
                        }

                        this.braintree_dropin_instance = dropinInstance;
                    }
                );
            });
        },

        saveCard() {
            this.loading = true;

            this.braintree_dropin_instance.requestPaymentMethod((error, payload) => {
                if (error) {
                    return false;
                }

                this.displayNewBraintreeCardForm = false;
                this.loading = true;
                this.cards_errors = "";

                this.$http
                    .post(api.actions.save_braintree_customer_card, { payment_method_nonce: payload.nonce })
                    .then((result) => {
                        this.loading = false;

                        if (result.data.error) {
                            this.cards_errors = result.data.message;
                            return;
                        } else {
                            this.loading = false;
                            this.hasCard = true;
                            this.checkUserCard();
                        }
                    });
            });
        },

        saveCardAndPay() {
            this.loading = true;

            this.braintree_dropin_instance.requestPaymentMethod((error, payload) => {
                if (error) {
                    return false;
                }

                this.displayNewBraintreeCardForm = false;
                this.loading = true;

                this.$http
                    .post(api.actions.save_braintree_customer_card, { payment_method_nonce: payload.nonce })
                    .then((result) => {
                        this.loading = false;

                        if (result.error) {
                            this.cards_errors = result.error.message;
                            return;
                        } else {
                            this.loading = false;
                            this.hasCard = true;
                            this.chargePayment();
                        }
                    });
            });
        },
        chargePayment() {
            this.loading = true;
            this.$http.get(api.actions.get_braintree_customer_cards).then((response) => {
                if (response.data.error == true || !response.data.response.length) {
                    this.loading = false;
                    this.hasCard = false;
                    return;
                }

                var payment_method = response.data.response[0];

                response.data.response.forEach((el) => {
                    if (el.default) {
                        payment_method = el;
                    }
                });

                var fields = {
                    number: this.buyMessagesNumber,
                    type: this.messageType,
                    payment_method_token: payment_method.payment_method_token,
                };

                this.$http.post(api.actions.charge_marketing_campaign_payment, fields).then(() => {
                    this.loading = false;
                    this.preview = true;

                    setTimeout(() => {
                        this.getCampaignSettings();
                    }, 2000);
                });
            });
        },
        manualChargePayment() {
            this.loading = true;
            this.$http.get(api.actions.get_braintree_customer_cards).then((response) => {
                if (response.data.error == true || !response.data.response.length) {
                    this.loading = false;
                    this.hasCard = false;
                    return;
                }

                var payment_method = response.data.response[0];

                response.data.response.forEach((el) => {
                    if (el.default) {
                        payment_method = el;
                    }
                });

                var fields = {
                    number: this.buyMessagesNumber,
                    type: this.messageType,
                    payment_method_token: this.default_payment_method
                        ? this.default_payment_method
                        : payment_method.payment_method_token,
                };

                this.$http.post(api.actions.charge_marketing_campaign_payment, fields).then((response) => {
                    this.loading = false;

                    if (response.data.error == true) {
                        messages.errorMessage(messages.ERROR_MESSAGES.PAYMENT_ERROR);
                        return;
                    }

                    messages.successMessage(messages.GLOBAL_MESSAGES.PAYMENT_SUCCESS);
                    this.agreeTerms = false;

                    setTimeout(() => {
                        this.getCampaignSettings();
                    }, 2000);

                });
            });
        },
        checkCardForm() {
            this.setMessagesNumberBuy();

            if (!this.hasAvailableMessages() && !this.hasCard) {
                this.addNewBraintreeCard();
            }
        },
        getTotalMessageCost() {
            var price = this.messageType == "sms" ? this.sms_cost : this.email_cost;

            return (price * this.buyMessagesNumber).toFixed(2);
        },
        checkMessagesNumberBuy() {
            if (this.messageType == "sms" && this.buyMessagesNumber < this.minSMSBuyNumber) {
                this.buyMessagesNumber = this.minSMSBuyNumber;
            } else if (this.messageType == "email" && this.buyMessagesNumber < this.minEmailBuyNumber) {
                this.buyMessagesNumber = this.minEmailBuyNumber;
            }
        },
        setMessagesNumberBuy() {
            var clients = this.getSelectedGroupNumber();

            if (this.messageType == "sms") {
                if (clients > this.availableSMS && this.minSMSBuyNumber < clients - this.availableSMS) {
                    this.minSMSBuyNumber = clients - this.availableSMS;
                } else {
                    this.minSMSBuyNumber = 100;
                }

                this.buyMessagesNumber = this.minSMSBuyNumber;
            } else if (this.messageType == "email") {
                if (clients > this.availableEmails && this.minEmailBuyNumber < clients - this.availableEmails) {
                    this.minEmailBuyNumber = clients - this.availableEmails;
                } else {
                    this.minEmailBuyNumber = 1000;
                }

                this.buyMessagesNumber = this.minEmailBuyNumber;
            }
        },
        onCampaignPreview() {
            if (this.adminDetails.web_trial == true) {
                //messages.errorMessage(messages.ERROR_MESSAGES.TRIAL_USER_MARKETING);
                //return;
            }

            this.clientsNumber = this.getSelectedGroupNumber();

            if (this.messageType != "push" && !this.hasAvailableMessages()) {
                if (this.hasCard) {
                    this.chargePayment();
                } else {
                    this.saveCardAndPay();
                }
                return;
            }

            this.preview = true;
        },
        onCampaignSend() {
            if (this.messageType == "push") {
                this.sendCustomNotification();
                return;
            }

            this.loading = true;
            var data = {
                type: this.messageType,
                subject: this.data.title,
                message: this.data.message,
            };

            switch (this.data.onlyOpen) {
                case "today":
                case "tomorrow":
                case "this_week":
                case "next_week":
                    data.only_open = 1;
                    data.only_open_interval = this.data.onlyOpen;
                    break;
                case "open":
                    data.only_open = 1;
                    break;
                case "all":
                    data.only_open = 0;
                    break;
            }

            this.$http.post(api.actions.send_marketing_campaign_message, data).then((response) => {
                if (response.data.error == true) {
                    this.email_text_error = response.data.message;
                    this.loading = false;
                    this.preview = false;

                    return;
                }

                this.getCampaignSettings();
                this.getLastCustomNotification();
                this.loading = false;
                this.preview = false;
                this.data.title = "";
                this.data.message = "";
                this.email_text_error = "";
                messages.successMessage(messages.GLOBAL_MESSAGES.MESSAGE_SENT);
            });
        },
        getCampaignLog(type) {
            this.logDisplayType = type;

            const method =
                type === "sms"
                    ? "get_marketing_campaign_log_sms"
                    : "get_marketing_campaign_log";

            this.$http.get(api.actions[method]).then((response) => {
                if (response.data.error === true) {
                    this.campaignLog = [];
                    this.campaignLogTotal = 0;
                    this.campaignLogSMS = [];
                    this.logDisplayType = "";
                    return;
                }

                if (type === "sms") {
                    this.campaignLogSMS = response.data.logs;
                } else {
                    this.campaignLog = response.data.log;
                }

                this.campaignLogTotal = response.data.total_sent;

                const modalEl = document.getElementById("history-modal");
                let modal = Modal.getInstance(modalEl);

                if (!modal) {
                    modal = new Modal(modalEl);
                }

                modal.show();
            });
        },
        getFormattedDate(date, format) {
            return moment(date).format(format);
        },
        saveAutoreloadSmsSettings() {
            let data = {
                autoreload_sms: this.autoreload_sms,
                autoreload_sms_number: this.autoreload_sms_number,
                autoreload_sms_limit: this.autoreload_sms_limit,
            };
            this.$http.post(api.actions.save_autoreload_sms_settings, data).then((response) => {
                if (response.data.error == true) {
                    return;
                }

                messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);
                this.getCampaignSettings();
            });
        },
        splitText() {
            if (!this.details.message) {
                return;
            }

            const parts = this.details.message.split(":");
            if (parts.length === 2) {
                this.last_email_title_send = parts[0].trim();
                this.last_email_message_send = parts[1].trim();
            }
        },
        filterAmountAutoReload: function () {
            this.autoreload_sms_number = this.autoreload_sms_number.replace(/[^\d]/, "");
        },
    },
    components: {
        MainLoader,
    },
};
</script>
